
import React  from 'react';
import { Link, useRouteMatch } from 'react-router-dom';
import { Container } from './styles';
import { AiOutlineFileSearch, AiOutlineShoppingCart, AiOutlineUserAdd } from 'react-icons/ai';
import { CgCalculator } from 'react-icons/cg';
import { IoNewspaperOutline, IoStorefrontOutline, IoTicketOutline } from 'react-icons/io5';
import { HiOutlineTicket } from 'react-icons/hi';
import { RiUserSettingsLine, RiQuestionnaireLine } from 'react-icons/ri';
import { FaUsers, FaUsersCog } from 'react-icons/fa';

function CustomLink({ icone, label, to, activeOnlyWhenExact, fechaMenu, redirect }) {
	let match = useRouteMatch({
		path: to,
		exact: activeOnlyWhenExact
	});

	function pegaIcone(){

		switch(icone) {

			case 'FaUsersCog' : 
				return <FaUsersCog style={{ color: match ? '#3fb6fa' : '' }} />;

			case 'IoTicketOutline' : 
				return <IoTicketOutline style={{ color: match ? '#3fb6fa' : '' }} />;

			case 'RiQuestionnaireLine' : 
				return <RiQuestionnaireLine style={{ color: match ? '#3fb6fa' : '' }} />;

			case 'FaUsers' : 
				return <FaUsers style={{ color: match ? '#3fb6fa' : '' }} />;

			case 'IoStorefrontOutline' : 
				return <IoStorefrontOutline style={{ color: match ? '#3fb6fa' : '' }} />;

			case 'AiOutlineFileSearch' : 
				return <AiOutlineFileSearch style={{ color: match ? '#3fb6fa' : '' }} />;

			case 'CgCalculator' :
				return <CgCalculator style={{ color: match ? '#3fb6fa' : '' }} />;

			case 'IoNewspaperOutline' :
				return <IoNewspaperOutline style={{ color: match ? '#3fb6fa' : '' }} />	

			case 'AiOutlineUserAdd': 
				return <AiOutlineUserAdd style={{ color: match ? '#3fb6fa' : '' }} />	

			case 'AiOutlineUserAdd': 
				return <HiOutlineTicket style={{ color: match ? '#3fb6fa' : '' }} />		

			case 'AiOutlineShoppingCart': 
				return <AiOutlineShoppingCart style={{ color: match ? '#3fb6fa' : '' }} />	 

			case 'RiUserSettingsLine': 
				return <RiUserSettingsLine style={{ color: match ? '#3fb6fa' : '' }} />		

			default: return <AiOutlineFileSearch /> 
		}		
	}

	return (
		<Container >
			<Link onClick={label === "Catálogo" ? redirect : fechaMenu} style={{ color: match ? '#3fb6fa' : ''}} to={to} >
				{pegaIcone()}{label}
			</Link>
			{match && <div />}
		</Container>
	);
}

export default CustomLink;